var _rect, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 343.10001 158.60001",
    width: 465,
    height: 215,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "acu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 343.10001,
    height: 158.60001,
    fill: "#3c1053"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shield"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shield-whole",
    d: "M89.4,29.8V63.4c0,17-11.4,35.6-29.8,42.9C41.2,98.9,29.8,80.4,29.8,63.4V29.8H89.4Z",
    transform: "translate(0 0.00003)",
    fill: "#da291c"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "shield-diamond",
    points: "40.9 63.5 59.6 38.8 78.4 63.5 59.6 88.2 40.9 63.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shield-cross",
    d: "M57.9,66.9a80.04,80.04,0,0,0,1.7,14.7h0a81.38744,81.38744,0,0,0,1.7-14.7V65.3H67v0.4a2.0757,2.0757,0,0,0,1.7,2.1,1.99169,1.99169,0,0,0,1.7-2.1V65.3h0.4a2.0757,2.0757,0,0,0,2.1-1.7,1.99169,1.99169,0,0,0-2.1-1.7H70.4V61.5a2.0757,2.0757,0,0,0-1.7-2.1A1.99169,1.99169,0,0,0,67,61.5v0.4H61.4V55.3h0.4a2.0757,2.0757,0,0,0,2.1-1.7,1.99169,1.99169,0,0,0-2.1-1.7H61.4V51.5a2.0757,2.0757,0,0,0-1.7-2.1A1.99169,1.99169,0,0,0,58,51.5v0.4H57.6a2.0757,2.0757,0,0,0-2.1,1.7,1.99169,1.99169,0,0,0,2.1,1.7H58v6.6H52.4V61.5a2.0757,2.0757,0,0,0-1.7-2.1A1.99169,1.99169,0,0,0,49,61.5v0.4H48.6a2.0757,2.0757,0,0,0-2.1,1.7,1.99169,1.99169,0,0,0,2.1,1.7H49v0.4a2.0757,2.0757,0,0,0,1.7,2.1,1.99169,1.99169,0,0,0,1.7-2.1V65.3H58v1.6H57.9Z",
    transform: "translate(0 0.00003)",
    fill: "#da291c"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "full-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "A--USTRALIAN",
    d: "M36.3,118.1H34.6l-4.8,10.7h1.9l1-2.3h5.6l1,2.3h1.8l-4.7-10.5Zm1.3,6.9H33.4l2.1-4.8Z",
    transform: "translate(0 0.00003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A--U--STRALIAN",
    d: "M48.9,124.5a2.677,2.677,0,0,1-2.7,2.9,2.62619,2.62619,0,0,1-2.7-2.9v-6.4H41.8v6.4a4.40111,4.40111,0,1,0,8.8,0v-6.4H48.9v6.4Z",
    transform: "translate(0 0.00003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AU--S--TRALIAN",
    d: "M57.2,122.5c-1.6-.2-2.6-0.6-2.6-1.5,0-1,1.2-1.5,2.5-1.5a3.101,3.101,0,0,1,2.7,1.3l0.1,0.2,1.3-.8-0.1-.2a4.49467,4.49467,0,0,0-4.1-2,4.90386,4.90386,0,0,0-3.4,1.2,2.48948,2.48948,0,0,0-.7,1.9c0,2.4,2.5,2.8,4.1,3,1.7,0.3,2.8.6,2.8,1.7,0,1.6-2.1,1.7-2.7,1.7a3.27524,3.27524,0,0,1-3.1-1.7l-0.1-.2-1.4.8,0.1,0.2a4.62452,4.62452,0,0,0,4.5,2.5c2.1,0,4.4-.9,4.4-3.3C61.4,123.4,59.2,122.8,57.2,122.5Z",
    transform: "translate(0 0.00003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "AUS--T--RALIAN",
    points: "62.2 119.7 65.7 119.7 65.7 128.8 67.4 128.8 67.4 119.7 70.9 119.7 70.9 118.1 62.2 118.1 62.2 119.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AUST--R--ALIAN",
    d: "M81.2,121.6a3.46366,3.46366,0,0,0-3.7-3.5H72.6v10.7h1.7v-3.7h2.2l3.2,3.7h2.2L78.5,125A3.135,3.135,0,0,0,81.2,121.6Zm-6.8-1.9h3.2a1.941,1.941,0,0,1,2,2,1.83853,1.83853,0,0,1-2.1,1.9H74.4v-3.9Z",
    transform: "translate(0 0.00003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AUSTR--A--LIAN",
    d: "M89,118.1H87.3l-4.8,10.7h1.9l1-2.3H91l1,2.3h1.8L89,118.3v-0.2Zm1.3,6.9H86l2.1-4.8Z",
    transform: "translate(0 0.00003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "AUSTRA--L--IAN",
    points: "97.2 118.1 95.5 118.1 95.5 128.8 102.7 128.8 102.7 127.2 97.2 127.2 97.2 118.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "AUSTRAL--I--AN",
    x: 104.2,
    y: 118.1,
    width: 1.7,
    height: 10.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "AUSTRALI--A--N",
    d: "M114.1,118.1h-1.7l-4.8,10.7h1.9l1-2.3h5.6l1,2.3h1.8l-4.7-10.5Zm1.3,6.9h-4.2l2.1-4.8Z",
    transform: "translate(0 0.00003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "AUSTRALIA--N",
    points: "127.7 125.6 121.8 118.1 120.6 118.1 120.6 128.8 122.3 128.8 122.3 121.4 128.2 128.8 129.4 128.8 129.4 118.1 127.7 118.1 127.7 125.6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C--ATHOLIC",
    d: "M145.5,126.3a4.10555,4.10555,0,0,1-2.8,1.1c-2.8,0-3.8-2.1-3.9-3.9a3.66511,3.66511,0,0,1,3.9-3.9,3.86368,3.86368,0,0,1,2.7,1.1l0.1,0.1,1.2-1.1-0.2-.2a5.70181,5.70181,0,0,0-3.9-1.6,5.512,5.512,0,0,0-4,1.5,5.82575,5.82575,0,0,0-1.6,4.1,5.26016,5.26016,0,0,0,5.6,5.5,5.50745,5.50745,0,0,0,4-1.6l0.2-.1-1.2-1.2Z",
    transform: "translate(0 0.00003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C--A--THOLIC",
    d: "M154,118.1h-1.7l-4.8,10.7h1.9l1-2.3H156l1,2.3h1.8l-4.7-10.5Zm1.3,6.9h-4.2l2.1-4.8Z",
    transform: "translate(0 0.00003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "CA--T--HOLIC",
    points: "158.4 119.7 161.9 119.7 161.9 128.8 163.5 128.8 163.5 119.7 167 119.7 167 118.1 158.4 118.1 158.4 119.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "CAT--H--OLIC",
    points: "176 122.6 170.5 122.6 170.5 118.1 168.8 118.1 168.8 128.8 170.5 128.8 170.5 124.2 176 124.2 176 128.8 177.7 128.8 177.7 118.1 176 118.1 176 122.6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CATH--O--LIC",
    d: "M185.1,117.9a5.33028,5.33028,0,0,0-5.5,5.6,5.4009,5.4009,0,1,0,10.8,0A5.14721,5.14721,0,0,0,185.1,117.9Zm0,9.5a3.60839,3.60839,0,0,1-3.7-3.9,3.71125,3.71125,0,1,1,7.4,0A3.615,3.615,0,0,1,185.1,127.4Z",
    transform: "translate(0 0.00003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "CATHO--L--IC",
    points: "194.1 118.1 192.4 118.1 192.4 128.8 199.7 128.8 199.7 127.2 194.1 127.2 194.1 118.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "CATHOL--I--C",
    x: 201.2,
    y: 118.1,
    width: 1.7,
    height: 10.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "CATHOLI--C",
    d: "M213.2,126.3a4.10555,4.10555,0,0,1-2.8,1.1c-2.8,0-3.8-2.1-3.9-3.9a3.66511,3.66511,0,0,1,3.9-3.9,3.86368,3.86368,0,0,1,2.7,1.1l0.1,0.1,1.2-1.1-0.2-.2a5.70181,5.70181,0,0,0-3.9-1.6,5.512,5.512,0,0,0-4,1.5,5.82575,5.82575,0,0,0-1.6,4.1,5.26016,5.26016,0,0,0,5.6,5.5,5.50745,5.50745,0,0,0,4-1.6l0.2-.1-1.2-1.2Z",
    transform: "translate(0 0.00003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U--NIVERSITY",
    d: "M228.7,124.5a2.677,2.677,0,0,1-2.7,2.9,2.6262,2.6262,0,0,1-2.7-2.9v-6.4h-1.7v6.4a4.40111,4.40111,0,1,0,8.8,0v-6.4h-1.7v6.4Z",
    transform: "translate(0 0.00003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "U--N--IVERSITY",
    points: "240.3 125.6 234.4 118.1 233.2 118.1 233.2 128.8 234.9 128.8 234.9 121.4 240.8 128.8 242 128.8 242 118.1 240.3 118.1 240.3 125.6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "UN--I--VERSITY",
    x: 244.89999,
    y: 118.1,
    width: 1.7,
    height: 10.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "UNI--V--ERSITY",
    points: "250.2 118.1 248.3 118.1 252.8 128.8 254.4 128.8 258.8 118.1 257 118.1 253.6 126.6 250.2 118.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "UNIV--E--RSITY",
    points: "262.3 124.1 267.9 124.1 267.9 122.5 262.3 122.5 262.3 119.7 268.2 119.7 268.2 118.1 260.6 118.1 260.6 128.8 268.4 128.8 268.4 127.2 262.3 127.2 262.3 124.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "UNIVE--R--SITY",
    d: "M279.3,121.6a3.46368,3.46368,0,0,0-3.7-3.5h-4.9v10.7h1.7v-3.7h2.2l3.2,3.7H280l-3.4-3.8A3.21248,3.21248,0,0,0,279.3,121.6Zm-6.9-1.9h3.2a1.94106,1.94106,0,0,1,2,2,1.83853,1.83853,0,0,1-2.1,1.9h-3.1v-3.9Z",
    transform: "translate(0 0.00003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "UNIVER--S--ITY",
    d: "M285.6,122.5c-1.6-.2-2.6-0.6-2.6-1.5,0-1,1.2-1.5,2.5-1.5a3.101,3.101,0,0,1,2.7,1.3l0.1,0.2,1.3-.8-0.1-.2a4.49467,4.49467,0,0,0-4.1-2,4.90382,4.90382,0,0,0-3.4,1.2,2.48949,2.48949,0,0,0-.7,1.9c0,2.4,2.5,2.8,4.1,3,1.7,0.3,2.8.6,2.8,1.7,0,1.6-2.1,1.7-2.7,1.7a3.27526,3.27526,0,0,1-3.1-1.7l-0.1-.2-1.4.8,0.1,0.2a4.62452,4.62452,0,0,0,4.5,2.5c2.1,0,4.4-.9,4.4-3.3S287.7,122.8,285.6,122.5Z",
    transform: "translate(0 0.00003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "UNIVERS--I--TY",
    x: 292,
    y: 118.1,
    width: 1.70001,
    height: 10.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "UNIVERSI--TY",
    points: "305.4 118.1 295.5 118.1 295.5 119.7 299.1 119.7 299.1 128.8 300.7 128.8 300.7 119.7 304.3 119.7 307.5 124.5 307.5 128.8 309.2 128.8 309.2 124.5 313.2 118.5 313.3 118.4 313.3 118.1 311.4 118.1 308.4 122.8 305.4 118.1",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "acronym"
  }, /*#__PURE__*/React.createElement("path", {
    id: "acro-U",
    d: "M313.3,29.8V76.6c0,24.8-19.4,28.5-28,28.5-15.5,0-31.9-5.4-31.9-29.2V29.8h14.3V77c0,13.9,6.7,21.9,18.1,21.9,10.7,0,19.2-7,19.2-21.3V29.8h8.3Z",
    transform: "translate(0 0.00003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "acro-C",
    d: "M212.9,105.2c-24.8,0-39.8-17-39.8-37.5,0-20.2,15.7-39,41.6-39a35.89533,35.89533,0,0,1,22.1,8.1c3.1,2.5,5.9,6.6,5.9,10.1a7.5,7.5,0,1,1-15,0,7.59808,7.59808,0,0,1,2.1-5.2c-3.3-4.3-10-6.5-15.4-6.5-17.2,0-27.3,16-27.3,31.4,0,17.8,11.4,32.4,29.2,32.4,9.1,0,16.3-3.8,23.7-9.3l2.8,4C234.7,101.6,223.3,105.2,212.9,105.2Z",
    transform: "translate(0 0.00003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "acro-A",
    d: "M157.7,104h13.9L143,29.9H131.8l-28.4,74.2h7.8l7.9-21.4h30.6ZM121.4,76.7l13-35.1,13.1,35.1H121.4Z",
    transform: "translate(0 0.00003)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcu);
export default __webpack_public_path__ + "static/media/ACU.c2521533bbdbfe9c49098ec85f2a9e6e.svg";
export { ForwardRef as ReactComponent };